import { RefObject, useEffect } from 'react'
import { useFormikContext } from 'formik'

import { isFirstIn } from './is-first-in.js'

export const useFocusOnFirstError = (
  name: string,
  scrollRef: RefObject<HTMLElement | null>,
  focusRef?: RefObject<HTMLInputElement | null>
): void => {
  const { errors, isSubmitting, isValidating } = useFormikContext()

  useEffect(() => {
    if (isSubmitting && !isValidating && isFirstIn(errors, name)) {
      focusRef?.current?.focus()
      scrollRef.current?.scrollIntoView?.({ behavior: 'smooth', block: 'center', inline: 'center' })
    }
  }, [errors, name, isSubmitting, isValidating, scrollRef, focusRef])
}
